import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_69jqux09qb: FaireBrandEntity = {
  token: "b_69jqux09qb",
  type: "brand",
  name: "Me Mother Earth",
  avatarUrl:
    "https://cdn.faire.com/fastly/1aff66a8b49b5061d70c8c2443c4bfd3669f5892a33440a945033631dac6ce52.png",
  bannerUrl:
    "https://cdn.faire.com/fastly/f65579f8af7f91afad263b6ba7b84e097dd66cb703e6075875bd2b6002e74b0a.jpeg",
  logoUrl:
    "https://cdn.faire.com/fastly/1aff66a8b49b5061d70c8c2443c4bfd3669f5892a33440a945033631dac6ce52.png",
  heroImageUrl:
    "https://cdn.faire.com/fastly/f65579f8af7f91afad263b6ba7b84e097dd66cb703e6075875bd2b6002e74b0a.jpeg",
  location: "Las Vegas, NV, USA",
  minimumOrderDollars: 110,
  rating: 5,
  reviewCount: 515,
  isTopShop: true,
  isInsider: true,
  description:
    "We are a husband and wife team local to Las Vegas, Alberto is originally from Rio, Brazil and myself, Amanda grew up in Washington state. As a couple who love to travel, we've been fortunate to see some of the most beautiful places on our Mother Earth. But we also witnessed first hand how our “throw away” culture is devastating our planet. We believe in the concept of progress, not perfection, and feel every individual has the ability to make an impact. \n\nBy swapping to earth-friendly products, we can help reduce plastic waste, send a clear message to corporate polluters, and provide a cleaner planet for all.\n\nWe stand behind our quality and believe you + your customers will love our products as much as we do.",
  meta: {
    source: "api",
    importedAt: "2026-03-25T23:44:38.497Z",
    importedBy: "entity-db-cli",
  },
};
